import React from "react";

export function AppConnectionWindow() {
    return (
        <div>
            AppConnectionWindow
        </div>
    )
}